import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { UrgencyBoostFormGroup } from '../../model';
import { POLARIS_PADDING_OPTIONS } from '../../../../shared/config/polaris-padding';

@Component({
  selector: 'urgency-boost-form-settings',
  templateUrl: './urgency-boost-form-settings.component.html',
  styleUrls: ['./urgency-boost-form-settings.component.scss'],
  standalone: false,
})
export class UrgencyBoostFormSettingsComponent {
  @Input() formGroup: FormGroup<UrgencyBoostFormGroup>;

  topMarginOptions = POLARIS_PADDING_OPTIONS;
}
